import Script from "next/script";

export function AdSenseScript() {
  const adClient = process.env.NEXT_PUBLIC_ADSENSE_PUBLISHER_ID;

  if (!adClient) {
    return null;
  }

  return (
    <Script
      async
      crossOrigin="anonymous"
      src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${adClient}`}
      strategy="afterInteractive"
    />
  );
}
